import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
var _effectorFileName = "/builds/gmini/front-common/src/components/VersionSwitch/NamedVersions/ChangeVersionName.tsx";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.is-array.js";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useRef, useState } from 'react';
import { RoundedCross } from '@gmini/ui-kit';
import { Backdrop, CloseButton } from "../VersionHistory.styled";
import { CancelButton, CancelButtonText, ChangeNameFooterWrap, ChangeNameForm, ChangeNameInput, ChangeNameTitle, ChangeNameWrap, Divider, Header, HeaderTitle, MainContainer, RenameButton, RenameButtonText } from "./ChangeVersionName.styled";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var ChangeVersionNameWrapped = function ChangeVersionNameWrapped(_ref) {
  var onClose = _ref.onClose,
      onSubmitChangeName = _ref.onSubmitChangeName,
      toRenameVersion = _ref.toRenameVersion;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      error = _useState2[0],
      setError = _useState2[1];

  var _React$useState = React.useState(''),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      name = _React$useState2[0],
      setName = _React$useState2[1];

  var changeNameInputRef = useRef(null);
  React.useEffect(function () {
    if (toRenameVersion && toRenameVersion.name) {
      setName(toRenameVersion.name);
    } else {
      setName('');
    }
  }, [toRenameVersion]);
  React.useEffect(function () {
    if (changeNameInputRef.current && toRenameVersion) {
      changeNameInputRef.current.focus();
    }
  }, [toRenameVersion]);
  var onCloseHandler = React.useCallback(function () {
    if (error) {
      setError(false);
    }

    if (name) {
      setName('');
    }

    onClose();
  }, [error, name, onClose]);

  var onSubmit = function onSubmit(e) {
    e.preventDefault();
    onRename();
  };

  var disabled = toRenameVersion && toRenameVersion.name === name || !name;
  var onRename = React.useCallback(function () {
    if (toRenameVersion && name) {
      onSubmitChangeName({
        name: name,
        version: toRenameVersion.version
      }).then(function () {
        return onCloseHandler();
      })["catch"](function () {
        return setError(true);
      });
    }
  }, [name, onCloseHandler, onSubmitChangeName, toRenameVersion]);

  var onChange = function onChange(e) {
    if (error) {
      setError(false);
    }

    setName(e.target.value);
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [toRenameVersion && /*#__PURE__*/_jsx(Backdrop, {}), toRenameVersion && /*#__PURE__*/_jsxs(MainContainer, {
      children: [/*#__PURE__*/_jsxs(Header, {
        children: [/*#__PURE__*/_jsx(HeaderTitle, {
          children: "\u0417\u0430\u0434\u0430\u0442\u044C \u0438\u043C\u044F \u0432\u0435\u0440\u0441\u0438\u0438 V00".concat(toRenameVersion.version)
        }), /*#__PURE__*/_jsx(CloseButton, {
          type: "square",
          onClick: onClose,
          children: /*#__PURE__*/_jsx(RoundedCross, {})
        })]
      }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsxs(ChangeNameWrap, {
        children: [/*#__PURE__*/_jsx(ChangeNameTitle, {
          children: "\u0418\u043C\u044F \u0432\u0435\u0440\u0441\u0438\u0438"
        }), /*#__PURE__*/_jsx(ChangeNameForm, {
          onSubmit: onSubmit,
          children: /*#__PURE__*/_jsx(ChangeNameInput, {
            ref: changeNameInputRef,
            error: error,
            onChange: onChange,
            placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0438\u043C\u044F",
            value: name,
            maxLength: 70
          })
        })]
      }), /*#__PURE__*/_jsxs(ChangeNameFooterWrap, {
        children: [/*#__PURE__*/_jsx(CancelButton, {
          children: /*#__PURE__*/_jsx(CancelButtonText, {
            onClick: onCloseHandler,
            children: "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C"
          })
        }), /*#__PURE__*/_jsx(RenameButton, {
          disabled: disabled,
          onClick: function onClick() {
            return !disabled && onRename();
          },
          children: /*#__PURE__*/_jsx(RenameButtonText, {
            children: "\u041F\u0435\u0440\u0435\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u0442\u044C"
          })
        })]
      })]
    })]
  });
};

export var ChangeVersionName = /*#__PURE__*/React.memo(ChangeVersionNameWrapped);
ChangeVersionName.displayName = 'ChangeVersionName';